import { useEffect, KeyboardEvent } from 'react';

import { useLocalStorage } from './useLocalStorage';

export const useKeyToggle = (keyName: string, persistenceName: string, initialValue?: boolean) => {
  const [lsValue, setValue] = useLocalStorage(persistenceName, initialValue || false);

  const value = !!lsValue;

  const toggleValue = () => setValue(!value);

  const keyListener = (ev: KeyboardEvent<Element>) => {
    const targetElement = (ev.target as HTMLElement).tagName?.toUpperCase();
    // Ignore key events from input, textarea, and select elements
    if (['INPUT', 'TEXTAREA', 'SELECT'].includes(targetElement)) {
      return;
    }

    if (ev.key.toLowerCase() === keyName.toLowerCase()) {
      ev.stopPropagation();
      ev.preventDefault();
      toggleValue();
    }
  };

  useEffect(() => {
    window.addEventListener('keyup', keyListener as never);
    return () => {
      window.removeEventListener('keyup', keyListener as never);
    };
  });

  return { value, setValue };
};
